import { Car, Bike, Truck, Container, AlertTriangle } from "lucide-react";

const SERVICES = [
  {
    icon: Car,
    title: "Guincho para Carros",
    desc: "Transporte seguro para veiculos leves de qualquer modelo.",
  },
  {
    icon: Bike,
    title: "Guincho para Motos",
    desc: "Remocao cuidadosa para motocicletas de todos os tipos.",
  },
  {
    icon: Truck,
    title: "Guincho para Pesados",
    desc: "Equipamentos robustos para veiculos pesados e maquinarios.",
  },
  {
    icon: Container,
    title: "Guincho para Caminhao",
    desc: "Capacidade para remocao de caminhoes e carretas.",
  },
];

export default function Services() {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="py-24 sm:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
            Nossos Servicos
          </div>
          <h2
            data-testid="services-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-4"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            O que <span className="text-[#FFD700]">fazemos</span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {SERVICES.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              data-testid="service-card"
              className="service-card bg-[#0A0A0A] border border-[#27272A] p-8 rounded-sm group cursor-default"
            >
              <div className="bg-[#1A1A1A] w-16 h-16 flex items-center justify-center rounded-sm mb-6 group-hover:bg-[#FFD700] transition-colors">
                <Icon className="w-8 h-8 text-[#FFD700] group-hover:text-black transition-colors" />
              </div>
              <h3
                className="text-xl font-bold uppercase tracking-tight mb-3 text-white"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        {/* Emergency badge */}
        <div
          data-testid="emergency-badge"
          className="flex items-center justify-center gap-3 bg-[#FFD700] text-black py-4 px-6 max-w-md mx-auto rounded-sm"
        >
          <AlertTriangle className="w-6 h-6 flex-shrink-0" />
          <span className="text-lg font-bold uppercase tracking-wide" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Atendimento Emergencial 24h
          </span>
        </div>
      </div>
    </section>
  );
}
